FD.SITE = (function ($, me) {
    'use strict';

    var child = me.SITE || {};





    /* ========================================================================
     *  private vars
     * ========================================================================
    */
    var ELEM = '[data-fd*="page-ctrl-"]';
    var PARENT = '[data-parent="true"]';
    var DATERANGE_ELEM = 'DATERANGE';
    var DATENAV_SELECT_ELEM = '[data-name=dateNavSelect],[data-type=dateNavSelect]';
    var DATENAV_NEXT_ELEM = '[data-name="dateNavNext"]';
    var DATENAV_PREV_ELEM = '[data-name="dateNavPrev"]';
    var DELETE_ELEM = '[data-fd="page-ctrl-delete"]';
    var DELETE_CONFIRM = '[data-fd="page-ctrl-confirmdelete"]';
    var DELETE_CANCEL = '[data-fd="page-ctrl-canceldelete"]';
    var DATEPICKER_PREV = '[data-name="datePickerPrev"]';
    var DATEPICKER_NEXT = '[data-name="datePickerNext"]';
    var DATEPICKER_TODAY = '[data-name="datePickerToday"]';
    var SELECT_PREV = '[data-name="selectPrev"]';
    var SELECT_NEXT = '[data-name="selectNext"]';
    var SELECT_ELEM = '[data-fd="page-ctrl-select"]';
    var EARLIEST_DATE = new Date('1/1/1753');
    var LATEST_DATE = new Date('12/31/9999');
    var INPUT_ELEM = '[data-fd="page-ctrl-input"]';
    var INPUTKEYUP_ELEM = '[data-fd="page-ctrl-inputkeyup"]';
    var BUTTON_ELEM = '[data-fd="page-ctrl-button"]';
    var COLLAPSE_ELEM = '[data-fd="page-ctrl-expandcollapse"]';
    var TOGGLE_ELEM = '[data-fd="page-ctrl-toggle"]';
    var DATENAV_PREV = '[data-name="dateNavPrev"]';
    var DATENAV_SELECT = '[data-name="dateNavSelect"],[data-type=dateNavSelect]';
    var DATENAV_NEXT = '[data-name="dateNavNext"]';
    var DATENAV_TODAY = '[data-name="dateNavToday"]';
    var DELAY = 800;

    var body = $('body');
    var list = [];      // all ctrls
    var selectedDate = false; // Used to avoid redundant datepicker calls
    var topControlClickedElement; // Used to allow for typing in top control datepicker

    //  defaults
    var defaults = {
        element: '',
        value: '',
        name: 'noname',
        autocompletetype: '',       //  only ac
        autocompleteinitialvalue: '',

        //  note: these come from the row
        callback: 'PAGE.getAfterControlEvent',  //   default
        tag: 0
    };

    /* ========================================================================
     *  handles
     * INPUT : input
     * INPUTKEYUP: inputkeyup
     * BUTTON : button
     * TOGGLE [T/F]:  toggle
     * SELECT : select
     * COMBO:  combodivcell, combodivfocusfactorycell, combodivfocusfactorysupercell
     * AUTOCOMPLETE,
     * DATERANGE
     * COLLPASE/EXPAND: collapse
     * DATEPICKER
     * DATENAV datenav
     * ========================================================================
    */


    /* ========================================================================
     *  div child combo vars
     * ========================================================================
    */

    var SELECT_DIVISION_CHILD_COMBO_ELEM = '[data-fd="page-ctrl-combodivchild"]';
    var SELECT_FOCUSFACTORY_CHILD_COMBO_ELEM = '[data-fd="page-ctrl-combofocusfactorychild"]';
    var DIVISION_CHILD_PREV = '[data-name="divisionChildPrev"]';
    var DIVISION_CHILD_NEXT = '[data-name="divisionChildNext"]';
    var FOCUSFACTORY_CHILD_PREV = '[data-name="focusfactoryChildPrev"]';
    var FOCUSFACTORY_CHILD_NEXT = '[data-name="focusfactoryChildNext"]';

    var COMBOTYPE = {
        DIVISION_CELL: 1,
        DIVISIONWITHFOCUSFACTORY_CELL: 2,
        DIVISIONWITHFOCUSFACTORY_SUPERCELL: 3,
        DIVISION_FOCUSFACTORYCELL: 4,
        DIVISIONFOCUSFACTORY_CELL: 5
    }

    var ALL_INNOTEC = 1;

    /* ========================================================================
     *  autocomplete vars
     * ========================================================================
    */
    //  autocomplete type
    var ACTYPE = {
        NONE: -1,
        USER: 1,
        CELL: 2,
        DIVISION: 3,
        CR: 4,
        DIVISIONCELLUSER: 5,
        DIVISIONCELLCR: 6,
        DIVISIONCELL: 7,
        DIVISIONCELLCRUSER: 8,
        MONTHLYMETRIC: 9,
        COMPANY: 10,
        COMPANYLOCATION: 11,
        UNIVERSALUSER: 12,
        PROJECTLIST: 13,
        FOCUSFACTORY: 14,
        SUPERCELL: 15,
        MACHINE: 16,
        STATION: 17,
        CUSTOMER: 18,
        VIEWID: 19,
        CRMENTOR: 20,
        INNOTECPART: 21,
        CUSTOMERPART: 22,
        NONFAILUREINTERVENTION: 23,
        DOWNTIMEISSUE: 24,
        MANUALPROCESS: 25,
        SCRAPDEFECT: 26,
        TAG: 27,
        EIGHTD: 28,
        TECHNICALCR: 29,
        CONTACT: 30,
        DOWNTIMEWARNING: 31,
        SPAREPARTLOCATION: 32,
        FOXENTITY: 33,
        USERCOMPLETELIST: 34,
        PROJECTENTITYLIST: 35,
        PROJECTMETRICACCOUNTS: 36,
        OTEACCOUNTS: 37,
        DIVISIONFOCUSFACTORYCELL: 38,
        INNOTECDIVISIONCELLCRUSER: 39,
        TRAININGMATRIXPLAYLIST: 40,
        DIVISIONGROUPDIVISIONFOCUSFACTORYSUPERCELLCELLMACHINESTATION: 41,
        MPTUSERS: 42,
        DIVISIONFOCUSFACTORY: 43,
        MANUALLABORCOMPANYLOCATION: 44,
        BOTRESPOSIBILITYPARENT: 45,
        ONEPPRESPOSIBILITYPARENT: 46,
        ONEPP_RESPONSIBILITY_ALL: 47,
        MPTUSERS_WITHCOMPANY: 48,
        JOB: 49,
        CONTPAQ_PRODUCTS: 50,
        USERS_EXCEPT_FULLTIME: 51,
        UNLINKED_SPARE_PART_PARTS: 52,
        UNLINKED_CONTPAQ_PRODUCTS: 53,
        PURCHASED_MATERIAL: 55,
        NON_CONTPAQ_VENDORS: 56,
        CONTPAQ_VENDORS_ONLY: 57,
        TRAINING_MATRIX_TEMPLATE: 59,
        JOB_EXCLUDE_LINKED: 60,
        TRAINING_MATRIX_ENTITY: 61,
        COMPANY_LOCATIONS_WITH_BOM: 62,
        COMPANY_LOCATIONS_WITH_SALES_ORDER: 63,
        NON_CUSTOMER_LOCATION: 64,
        CHILD_ACCOUNT: 66,
        SHIPTO: 69,
        COMPANY_LOCATIONS_WITH_BOM_SHIPTO: 70,
        PDT_PROJECT_NUMBER: 78,
        SHIPTO_AND_CELL_LIST: 79,
        INNOTECPART_WITHOUT_CELLNAME: 83,
        COMPANY_LOCATION_AND_CELLLIST: 88,
        CR_AND_USER: 89,
        EIGHTD_WITH_NAME: 92,
        CUSTOMERPART_WITH_SHIPTO_DESCRIPTION: 94
    };

    var URL = "/Common/Common/";


    /* ========================================================================
     *  row methods
     * ========================================================================
    */

    //  set top control element
    function setTopControlElement() {
        list = $(ELEM);

        if (list.length === 0) {
            return;
        }

        setEvents();

        list.each(function (i, e) {
            var elem = $(e);

            //  set options
            var options = $.extend({}, defaults, elem.data());
            options.element = elem;

            //  type
            options.type = options.fd.split("-")[2];

            //  set callback, tag
            var parent = elem.parents(PARENT);
            var parentCallBack = parent.data('callback');
            var parentTag = parent.data('tag');
            if (parentCallBack !== undefined) {
                options.callback = parent.data("callback");
            }
            if (parentTag !== undefined) {
                options.tag = parent.data("tag");
            }

            //  override tag if button type
            if (options.type === 'button') {
                var tag = elem.data('tag');
                if (tag !== undefined) options.tag = tag;

                //  remove popover if exist
                elem.data('target', '');
            }

            elem.data(options);

            if (options.type == 'inputautocomplete') {
                options.autocompletetype = options.autocompletetype.toUpperCase();
                elem.data(options);
                if (options.clearonload) {
                    elem.data('clearonload', false).attr('data-clearonload', false).val(elem.data('onloadvalue'));
                    options.clearonload = false;
                }
                setAutoCompleteContainer(elem);
            } else if (options.type == 'daterange') {
                elem.find('input').data('callback', options.callback).data('tag', options.tag);
            }

            setInitialValue(elem);
        });


    }

    function updateUrlState(elem, data) {
        var controlName = elem.data('name'),
            controlValue = data[controlName],
            entityType = data[controlName + "RawData"]?.entitytype,
            url = document.location.href;

        if (!controlName) {
            return;
        }

        // Ignore non-toggle buttons.
        if (elem.is(".btn:not(.btn-toggle)")) {
            return;
        }

        // Set dependent settings
        if (controlName == 'cellID') {
            if (data.divisionID) {
                url = me.updateQS(url, 'divisionID', data.divisionID);
            }
        }

        // Clear dependent settings
        if (controlName == 'divisionID') {
            if (data.cellID) {
                url = me.updateQS(url, 'cellID', data.cellID);
            }
        }

        // Use lowest level setting for entityID
        if (controlName == 'divisionID' || controlName == 'cellID') {
            var entityID = Number(data.divisionID) === ALL_INNOTEC ? -1 : (typeof data.cellID == 'undefined' || Number(data.cellID) === -1 ? data.divisionID : data.cellID);
            url = me.updateQS(url, 'entityID', entityID);
        }

        if (entityType) {
            url = me.updateQS(url, 'entityType', entityType);
        }

        // Update URL
        url = me.updateQS(url, controlName, controlValue);
        window.history.replaceState({}, document.title, url);
    }


    function setInitialValue(e) {
        var data = e.data();

        switch (data.type) {
            case 'toggle':
                data.value = e.hasClass('active') ? true : false;
                break;
            case 'button':
            case 'delete':
                data.value = false;
                break;
            case 'input':
            case 'inputkeyup':
                if (data.clearonload) {
                    data.clearonload = false;
                    e.data('clearonload', false).attr('data-clearonload', false).val(data.onloadvalue)
                }
                data.value = e.val();
                break;
            case 'select':
                if (data.clearonload) {
                    data.clearonload = false;
                    e.data('clearonload', false).attr('data-clearonload', false).val(data.onloadvalue)
                }
                if (data.enablearrows) {
                    var index = e.find('option:selected').index();
                    if (index == 0) {
                        e.closest('.control').find(SELECT_PREV).attr('disabled', true).find('i').removeClass('fa-angle-left');
                    } else if (index == e.find('option').length - 1) {
                        e.closest('.control').find(SELECT_NEXT).attr('disabled', true).find('i').removeClass('fa-angle-right');
                    }
                }
                data.value = e.val();
                break;
            case 'combodivchild':
                if (data.clearonload) {
                    data.clearonload = false;
                    e.data('clearonload', false).attr('data-clearonload', false).val(data.onloadvalue)
                }
                if (data.enablearrows) {
                    var index = e.find('option:selected').index();
                    if (index == 0) {
                        e.closest('.control').find(DIVISION_CHILD_PREV).attr('disabled', true).find('i').removeClass('fa-angle-left');
                    } else if (index == e.find('option').length - 1) {
                        e.closest('.control').find(DIVISION_CHILD_NEXT).attr('disabled', true).find('i').removeClass('fa-angle-right');
                    }
                }
                data.value = e.val();
                break;
            case 'combofocusfactorychild':
                if (data.clearonload) {
                    data.clearonload = false;
                    e.data('clearonload', false).attr('data-clearonload', false).val(data.onloadvalue)
                }
                if (data.enablearrows) {
                    var index = e.find('option:selected').index();
                    if (index == 0) {
                        e.closest('.control').find(FOCUSFACTORY_CHILD_PREV).attr('disabled', true).find('i').removeClass('fa-angle-left');
                    } else if (index == e.find('option').length - 1) {
                        e.closest('.control').find(FOCUSFACTORY_CHILD_NEXT).attr('disabled', true).find('i').removeClass('fa-angle-right');
                    }
                }
                data.value = e.val();
                break;
            case 'datepicker':
                if (e.is('input')) {
                    if (data.clearonload) {
                        data.clearonload = false;
                        e.data('clearonload', false).attr('data-clearonload', false).val(data.onloadvalue);
                    }
                    setDatePicker(e);
                }
                break;
            case 'daterange':
                setDateRange(e);
                break;
            case 'datenav':
                if (data.name === 'dateNavSelect') {
                    if (data.clearonload) {
                        data.clearonload = false;
                        e.data('clearonload', false).attr('data-clearonload', false).val(data.onloadvalue)
                    }
                    data.value = (data.name == 'dateNavSelect') ? e.val() : false;
                }
                break;
        }
        e.data(data);
    }


    /* ========================================================================
     *  date picker
     * ========================================================================
    */


    function setFormat(elem) {
        var data = elem.data();
        var format = data.format.toLowerCase();
        var theDate = new Date(elem.data('value'));

        switch (format) {
            case 'datefull': elem.val(moment(theDate).format("MMM DD, YYYY"));
                break;
            case 'dateverbose': elem.val(theDate.getFullDateFriendly());
                break;
            case 'dateshortmonthyear': elem.val(theDate.getMonthDateFriendly());
                break;
            case 'datedaymonthnum': elem.val(theDate.getDayMonthNum());
                break;
            default: elem.val(theDate.getDateFriendly());
        }
    }


    // previous day button
    function setDatePickerPrev(e, datePicker) {
        var addedTime = datePicker.data('mondaysonly') ? (86400000 * 7) /*1 week*/ : 86400000;
        var currentDate = new Date(datePicker.data('value'));
        var newDate = new Date((currentDate).getTime() - addedTime);
        if (currentDate.getDay() !== newDate.getDay()) {
            newDate = new Date((newDate).getTime() + 3600000);//fix day time saving issue
        }
        var minDate = new Date(datePicker.datepicker("option", "minDate"));
        if (minDate !== null && newDate < minDate) {
            return;
        }
        datePicker.datepicker('option', 'defaultDate', newDate).datepicker('setDate', newDate);
        datePicker.data('value', newDate.getDateFriendly());
        setFormat(datePicker);
        getControlSet(datePicker);
        handleArrowsAgainstMaxAndMinDate(datePicker);
    }


    // next day button
    function setDatePickerNext(e, datePicker) {
        var addedTime = datePicker.data('mondaysonly') ? (86400000 * 7) /*1 week*/ : 86400000;
        var currentDate = new Date(datePicker.data('value'));
        var newDate = new Date((currentDate).getTime() + addedTime);
        if (currentDate.getDay() === newDate.getDay()) {
            newDate = new Date((newDate).getTime() + 3600000);//fix day time saving issue
        }
        var maxDate = datePicker.datepicker("option", "maxDate");
        if (maxDate !== null && newDate > maxDate) {
            return;
        }
        datePicker.datepicker('option', 'defaultDate', newDate).datepicker('setDate', newDate);
        datePicker.data('value', newDate.getDateFriendly());
        setFormat(datePicker);
        getControlSet(datePicker);
        handleArrowsAgainstMaxAndMinDate(datePicker);
    }


    // current day button
    function setDatePickerToday(e, datePicker) {
        var newDate = new Date();
        if (datePicker.data('mondaysonly')) {
            var day = newDate.getDay();
            var diff = newDate.getDate() - day + (day == 0 ? -6 : 1); // adjust when day is sunday
            newDate = new Date(newDate.setDate(diff));
        }        
        datePicker.datepicker('option', 'defaultDate', newDate).datepicker('setDate', newDate);
        datePicker.data('value', newDate.getDateFriendly());
        setFormat(datePicker);
        getControlSet(datePicker);
    }


    function setDatePicker(e) {
        var data = e.data();
        var value = e.val();

        if (value === "" || value === undefined || value === null) {
            value = new Date();
        }

        var theDate = new Date(value);

        if (!theDate.isValid()) {
            theDate = new Date();
        }

        e.val(theDate.getDateFriendly());
        data.value = e.val();
        e.data('value', theDate.getDateFriendly());

        setFormat(e);

        var NAMESPACE = me.getUID('CTRL_');
        var parent = e.parent();
        //  set datepicker
        e.removeClass('hasDatepicker').on('blur keydown',
            function (event) {
                event.stopPropagation();
                if (event.which === 13 || event.keyCode === 13 || event.type === 'blur') {
                    if (topControlClickedElement.id != 'ui-datepicker-div' &&
                        $(topControlClickedElement).parents("#ui-datepicker-div").size() == 0) {
                        var tempDate = new Date(e.val());
                        var datestring = tempDate.getDateFriendly();

                        if (datestring === e.data('value')) {
                            e.datepicker("setDate", tempDate);
                            setFormat(e);
                            return;
                        }

                        if (!tempDate.isValid() || tempDate < EARLIEST_DATE || tempDate > LATEST_DATE) {
                            if (e.data('value') && e.data('value').length > 0) {
                                tempDate = new Date(e.data('value'));
                            }
                            if (!tempDate.isValid()) {
                                tempDate = new Date();
                            }
                        }

                        var maxDate = e.datepicker("option", "maxDate");
                        var minDate = e.datepicker("option", "minDate");
                        if ((maxDate && tempDate > new Date(maxDate)) || (minDate && tempDate < new Date(minDate))) {
                            tempDate = new Date(e.data('value'));
                        } else if (e.data('weekdaysonly') && (tempDate.getDay() === 0 || new Date(data.value).getDay() === 6)) {
                            tempDate = new Date(e.data('value'));
                        } else if (e.data('mondaysonly') && (tempDate.getDay() != 1)) {
                            tempDate = new Date(e.data('value'));
                        }

                        datestring = tempDate.getDateFriendly();
                        e.datepicker('setDate', datestring);
                        e.datepicker('option', 'defaultDate', datestring);
                        e.data('value', datestring);
                        setFormat(e);
                        getControlSet(e);
                        handleArrowsAgainstMaxAndMinDate(e);
                    }
                }
            }).datepicker({
                numberOfMonths: 2,
                defaultDate: data.value,
                buttonImageOnly: true,
                minDate: data.mindate,
                maxDate: data.maxdate,
                buttonText: "",
                showOn: "both",
                onSelect: function (dT, ui) {
                    if (e.data('weekdaysonly') && ((new Date(dT)).getDay() === 0 || ((new Date(dT)).getDay() === 6))) {
                        dT = e.data('value');
                    }
                    if (e.data('mondaysonly') && (new Date(dT)).getDay() != 1) {
                        dT = e.data('value');
                    }
                    e.datepicker('option', 'defaultDate', dT);
                    e.val(dT)
                        .data('value', dT);
                    setFormat(e);
                    getControlSet(e);
                    handleArrowsAgainstMaxAndMinDate(e);
                },
                beforeShowDay: function (date) {
                    if (e.data('weekdaysonly')) {
                        var dayOfWeek = date.getDay();
                        return [
                            !(dayOfWeek === 0 || dayOfWeek === 6),
                            "",
                            ""
                        ];
                    }
                    if (e.data('mondaysonly')) {
                        var dayOfWeek = date.getDay();
                        return [
                            (dayOfWeek === 1),
                            "",
                            ""
                        ];
                    }
                    return [true, "", ""];
                }
            });

        // set surrounding buttons
        $(document).off('click.pagectrl_datePickerPrev', DATEPICKER_PREV)
            .off('click.pagectrl_datePickerNext', DATEPICKER_NEXT)
            .off('click.pagectrl_datePickerToday', DATEPICKER_TODAY)
            .on({
                'click.pagectrl_datePickerPrev': function () {
                    setDatePickerPrev($(this), e);
                }
            }, DATEPICKER_PREV)
            .on({
                'click.pagectrl_datePickerNext': function () {
                    setDatePickerNext($(this), e);
                }
            }, DATEPICKER_NEXT)
            .on({
                'click.pagectrl_datePickerToday': function () {
                    setDatePickerToday($(this), e);
                }
            }, DATEPICKER_TODAY);
    }


    /* ========================================================================
     *  date range
     * ========================================================================
    */

    // setup date range control
    function setDateRange(elem) {
        var dateInputs = elem.find('input');
        var startDateInput = $(dateInputs[0]);
        var endDateInput = $(dateInputs[1]);
        for (var x = 0; x < dateInputs.length; x++) {
            var currentInput = $(dateInputs[x]);
            if (currentInput.data('clearonload')) {
                currentInput.data('clearonload', false).attr('data-clearonload', false).val(currentInput.data('onloadvalue'));
            }
            var value = currentInput.data("value");
            if (value === "" || value === undefined || value === null) {
                value = new Date();
            }
            var theDate = new Date(value);

            if (!theDate.isValid()) {
                theDate = new Date();
            }

            currentInput.data('value', theDate.getDateFriendly());
            setFormat(currentInput);
        }

        // Start Date
        startDateInput.removeClass('hasDatepicker').datepicker({
            numberOfMonths: 2,
            defaultDate: startDateInput.data('value'),
            showOn: "both",
            onSelect: function (dT, ui) {
                startDateInput.blur();
            }
        });

        // End Date
        endDateInput.removeClass('hasDatepicker').datepicker({
            numberOfMonths: 2,
            defaultDate: endDateInput.data('value'),
            showOn: "both",
            onSelect: function (dT, ui) {
                endDateInput.blur();
            }
        });

        dateInputs.on('blur', function (event) {
            event.stopPropagation();
            handleDateRangeUpdate($(event.target), startDateInput, endDateInput);
        }).on('keyup', function (event) {
            var elem = $(this);

            if (event.which == 27 || event.keyCode == 27) { // Escape Key
                elem.datepicker('setDate', elem.data('value'))
                return;
            } else if (event.which == 13 || event.keyCode == 13) { // Enter Key
                elem.blur();
            }
        });
    }


    function handleDateRangeUpdate(currentInput, startDateInput, endDateInput) {
        var tempDate = new Date(currentInput.datepicker("getDate"));

        if (topControlClickedElement.id != 'ui-datepicker-div' &&
            $(topControlClickedElement).parents("#ui-datepicker-div").size() == 0) {
            tempDate = new Date(currentInput.val());
            var datestring = tempDate.getDateFriendly();

            if (datestring == currentInput.data('value')) {
                currentInput.datepicker("setDate", tempDate);
                setFormat(currentInput);
                return;
            }
        } else if (new Date(currentInput.val()).getDateFriendly() == currentInput.data('value')) {
            return;
        }

        if (!tempDate.isValid() || currentInput.val().length == 0) {
            if (currentInput.data('value') && currentInput.data('value').length > 0) {
                tempDate = new Date(currentInput.data('value'));
            } if (!tempDate.isValid()) {
                tempDate = new Date();
            }
        }

        var datestring = tempDate.getDateFriendly();
        currentInput.datepicker('disable');
        currentInput.datepicker('setDate', datestring);
        currentInput.datepicker('option', 'defaultDate', datestring);
        currentInput.data('value', datestring).val(datestring);
        currentInput.datepicker('enable');
        setFormat(currentInput);

        validateDateRange(startDateInput, endDateInput);

        getControlSet(currentInput);
    }


    // Ensure start date is earlier and end date, and make sure the date is valid
    function validateDateRange(startDateInput, endDateInput) {
        var startDate = (startDateInput.val().length > 0) ? new Date(startDateInput.datepicker('getDate')) : new Date(startDateInput.data('value'));
        var endDate = (endDateInput.val().length > 0) ? new Date(endDateInput.datepicker('getDate')) : new Date(endDateInput.data('value'));

        if (startDate < EARLIEST_DATE || startDate > LATEST_DATE) {
            startDate = new Date(startDateInput.data('value'));
            startDateInput.datepicker('setDate', startDate);
            startDateInput.datepicker('option', 'defaultDate', startDate);
            startDateInput.data('value', startDate.getDateFriendly()).val(startDate.getDateFriendly());
            setFormat(startDateInput);
        }
        if (endDate < EARLIEST_DATE || endDate > LATEST_DATE) {
            endDate = new Date(endDateInput.data('value'));
            endDateInput.datepicker('setDate', endDate);
            endDateInput.datepicker('option', 'defaultDate', endDate);
            endDateInput.data('value', endDate.getDateFriendly()).val(endDate.getDateFriendly());
            setFormat(endDateInput);
        }
        if (startDate > endDate) {
            startDateInput.datepicker('setDate', endDate);
            startDateInput.datepicker('option', 'defaultDate', endDate);
            startDateInput.data('value', endDate.getDateFriendly()).val(endDate.getDateFriendly());
            setFormat(startDateInput);
        }
    }



    /* ========================================================================
     *  autocomplete
     * ========================================================================
    */

    //  set the containers
    function setAutoCompleteContainer(e) {
        if (e.length === 0) {
            return;
        }
        var data = e.data()

        //  set initial value (text value)
        if (data.autocompleteinitialvalue.length > 1) {
            e.val(data.autocompleteinitialvalue);
        }

        e.data('initial', e.val());

        //  initial
        var activate = false;
        var isSelect = false;
        var allowNull = (e.data('allownull')) ? e.data('allownull') : false;

        if (allowNull && !e.next().hasClass('fa-ban')) {
            e.after('<i class="fa fa-fw fa-ban" style="cursor:pointer;"></i>');
            var parent = e.parent();
            parent.find('.fa-ban').off().on('click', function () {
                e.val('').data('value', -1);
                getControlSet(e);
                e.data('initial', '');
            });
        }

        //  set autocomplete
        e.autocomplete({
            minLength: 1,
            delay: DELAY,
            autoSelect: true,
            autoFocus: true,
            focus: function () {
                return false; // dont fill input with highlighted value
            },
            source: getSourceByType,
            select: function (event, ui) {
                activate = true;
                isSelect = true;
                $(event.target).val(ui.item.label);
                e.data('initial', ui.item.label);
                //  set data
                e.data().value = ui.item.value;
                if (ui.item.usertype) {
                    e.data('usertype', ui.item.usertype);
                }
                if (ui.item.entitytype) {
                    e.data('entitytype', ui.item.entitytype);
                }               
                switch (ui.item.acType) {
                    case ACTYPE.TRAINING_MATRIX_ENTITY:
                        e.data({
                            entitytype: ui.item.entityType,
                            iscustomusergroup: ui.item.isCustomUserGroup
                        });
                        break;
                }

                getControlSet(e);

                return false;
            },
            close: function (event, ui) {
                activate = false;
                $('body').removeClass('out');
                if (!isSelect) {
                    $(event.target).val(e.data('initial'));
                }
                isSelect = false;

                if (data.clearexit) {
                    $(event.target).val('');
                    $(event.target).focus();
                }
            }
        }).autocomplete("instance")._renderItem = function (ul, item) {
            //  set scroll
            ul.css({ 'max-height': data.height + 'px', 'overflow-y': 'auto', 'overflow-x': 'hidden' });

            var entityType = item.entitytype;

            if ((entityType === ACTYPE.USER || entityType === ACTYPE.USERCOMPLETELIST) && item.acType !== ACTYPE.TRAINING_MATRIX_ENTITY) {
                var image = item.userImage;
                var style = " background-image:url(" + image + ");";

                if (item.guid === undefined) {
                    style = '';
                }
                return $("<li>")
                    .append("<div class='user-autocomplete'><div class='image' style='" + style + "'></div><div class='content'>" + item.label + "</div></div>")
                    .appendTo(ul);
            }
            return $("<li>")
                .append("<div>" + item.label + "</div>")
                .appendTo(ul);
        };

        //  set element events
        e.off('focus.ac click.ac blur.ac keyup.ac')
            .on('focus.ac', function () {
                $(this).val('');
            })
            .on('click.ac', function () {
                $(this).val('');
            })
            .on('blur.ac', function () {
                if (!activate) {
                    $(this).val(e.data('initial'));
                } else {
                    activate = false;
                }
            })
            .on('keyup.ac', function (event) {
                //  esc
                if (+event.which === 27 || +event.keyCode === 27) {
                    e.val(e.data('initial'));
                    return;
                }
            });


        function getSourceByType(request, response) {
            if (request.term.trim().length < 3) {
                return;
            }

            var searchType = ACTYPE[data.autocompletetype.toUpperCase()];

            var inputProps = {
                searchTerm: me.setHtmlEncode(request.term.trim()),
                autoCompleteType: searchType
            };

            //  lock screen [prevent page scroll]
            $('body').addClass('out');

            getDataSource(response, inputProps);
        }
    }


    function getDataSource(response, props) {
        var options = {
            params: props,
            url: URL + 'GetAutoCompleteByType',
            callback: afterData,
            isloader: true
        };
        me.AJAX.setAJAX(options);

        function afterData(data) {
            var result = data.data;

            switch (props.autoCompleteType) {
                case ACTYPE.COMPANY:
                case ACTYPE.TRAINING_MATRIX_TEMPLATE:
                    response($.map(result, function (item) {
                        return {
                            entitytype: -1,
                            label: item.Name,
                            guid: null,
                            initial: null,
                            parentID: null,
                            value: item.ID,
                            userImage: null
                        };
                    }));
                    break;
                case ACTYPE.MANUALLABORCOMPANYLOCATION:
                    response($.map(result, function (item) {
                        return {
                            entitytype: -1,
                            label: item.Name,
                            guid: null,
                            initial: null,
                            parentID: item.ParentID,
                            value: item.ID,
                            userImage: null
                        };
                    }));
                    break;
                case ACTYPE.BOTRESPOSIBILITYPARENT:
                case ACTYPE.ONEPPRESPOSIBILITYPARENT:
                    response($.map(result, function (item) {
                        return {
                            entitytype: -1,
                            label: item.StandardName,
                            guid: null,
                            initial: null,
                            parentID: item.ParentID,
                            value: item.ID,
                            userImage: null
                        };
                    }));
                    break;
                case ACTYPE.UNIVERSALUSER:
                    response($.map(result, function (item) {
                        return {
                            entitytype: -1,
                            label: item.Name,
                            guid: null,
                            initial: null,
                            parentID: item.ParentID,
                            value: item.ID,
                            usertype: item.UserType,
                            userImage: item.UserImage
                        };
                    }));
                    break;
                case ACTYPE.PROJECTLIST:
                case ACTYPE.INNOTECPART_WITHOUT_CELLNAME:
                    response($.map(result, function (item) {
                        return {
                            entitytype: -1,
                            label: item.ManagedName,
                            guid: null,
                            initial: null,
                            parentID: null,
                            value: item.ManagedID,
                            usertype: null,
                            userImage: item.UserImage
                        };
                    }));
                    break;
                case ACTYPE.FOCUSFACTORY:
                case ACTYPE.SUPERCELL:
                case ACTYPE.MACHINE:
                case ACTYPE.STATION:
                case ACTYPE.CRMENTOR:
                case ACTYPE.INNOTECPART:
                case ACTYPE.CUSTOMERPART:
                case ACTYPE.MANUALPROCESS:
                    response($.map(result, function (item) {
                        return {
                            entitytype: -1,
                            label: item.DisplayName,
                            guid: null,
                            initial: null,
                            parentID: null,
                            value: item.ManagedID,
                            usertype: null,
                            userImage: null
                        };
                    }));
                    break;
                case ACTYPE.VIEWID:
                    response($.map(result, function (item) {
                        return {
                            entitytype: -1,
                            label: item.DisplayName,
                            guid: null,
                            initial: null,
                            parentID: null,
                            value: item.ID,
                            usertype: null,
                            userImage: null
                        };
                    }));
                    break;
                case ACTYPE.PROJECTENTITYLIST: // custom entity list in Projects application
                case ACTYPE.PROJECTMETRICACCOUNTS:
                    response($.map(result, function (item) {
                        return {
                            entitytype: -1,
                            label: item.StandardName,
                            guid: null,
                            initial: null,
                            parentID: null,
                            value: item.ID,
                            usertype: null,
                            userImage: null
                        };
                    }));
                    break;
                case ACTYPE.NONFAILUREINTERVENTION:
                case ACTYPE.DOWNTIMEISSUE:
                case ACTYPE.DOWNTIMEWARNING:
                case ACTYPE.SCRAPDEFECT:
                case ACTYPE.UNLINKED_CONTPAQ_PRODUCTS:
                case ACTYPE.UNLINKED_SPARE_PART_PARTS:
                case ACTYPE.TAG:
                case ACTYPE.COMPANY_LOCATIONS_WITH_SALES_ORDER:
                    response($.map(result, function (item) {
                        return {
                            entitytype: -1,
                            label: item.Title,
                            guid: null,
                            initial: null,
                            parentID: null,
                            value: item.ID,
                            usertype: null,
                            userImage: null
                        };
                    }));
                    break;
                case ACTYPE.EIGHTD:
                    response($.map(result, function (item) {
                        return {
                            entitytype: -1,
                            label: item.ID8D,
                            guid: null,
                            initial: null,
                            parentID: null,
                            value: item.ID8D,
                            usertype: null,
                            userImage: null
                        };
                    }));
                    break;
                case ACTYPE.EIGHTD_WITH_NAME:
                    response($.map(result, function (item) {
                        return {
                            entitytype: -1,
                            label: item.ShortDescription,
                            guid: null,
                            initial: null,
                            parentID: null,
                            value: item.D8DID,
                            usertype: null,
                            userImage: null
                        };
                    }));
                    break;
                case ACTYPE.TECHNICALCR:
                    response($.map(result, function (item) {
                        return {
                            entitytype: -1,
                            label: item.EntityName,
                            guid: null,
                            initial: null,
                            parentID: null,
                            value: item.EntityID,
                            usertype: null,
                            userImage: null
                        };
                    }));
                    break;
                case ACTYPE.SPAREPARTLOCATION:
                    response($.map(result, function (item) {
                        return {
                            entitytype: -1,
                            label: item.LocationName,
                            guid: null,
                            initial: null,
                            parentID: null,
                            value: item.LocationID,
                            usertype: null,
                            userImage: null
                        };
                    }));
                    break;
                case ACTYPE.OTEACCOUNTS:
                    response($.map(result, function (item) {
                        return {
                            entitytype: -1,
                            label: item.AccountName,
                            guid: null,
                            initial: null,
                            parentID: null,
                            value: item.AccountID,
                            usertype: null,
                            userImage: null
                        };
                    }));
                    break;
                case ACTYPE.TRAININGMATRIXPLAYLIST:
                    response($.map(result, function (item) {
                        return {
                            entitytype: -1,
                            label: item.Title,
                            guid: null,
                            initial: null,
                            parentID: null,
                            value: item.ID,
                            usertype: null,
                            userImage: null
                        };
                    }));
                    break;
                case ACTYPE.JOB:
                case ACTYPE.JOB_EXCLUDE_LINKED:
                    response($.map(result, function (item) {
                        return {
                            entitytype: -1,
                            label: item.JobName,
                            guid: null,
                            initial: null,
                            parentID: null,
                            value: item.JobID,
                            usertype: null,
                            userImage: null
                        };
                    }));
                    break;
                case ACTYPE.CONTPAQ_PRODUCTS:
                    response($.map(result, function (item) {
                        return {
                            entitytype: -1,
                            label: item.StandardName,
                            contpaqProductID: item.ContpaqProductID,
                            contpaqName: item.Name,
                            initial: null,
                            parentID: null,
                            value: item.ID,
                            usertype: null,
                            userImage: null
                        };
                    }));
                    break;
                case ACTYPE.PURCHASED_MATERIAL:
                    response($.map(result, function (item) {
                        return {
                            label: item.PartNumber + ' - ' + item.Description,
                            value: item.ID
                        };
                    }));
                    break;
                case ACTYPE.CONTPAQ_VENDORS_ONLY:
                case ACTYPE.COMPANYLOCATION:
                case ACTYPE.NON_CONTPAQ_VENDORS:
                case ACTYPE.COMPANY_LOCATIONS_WITH_BOM:
                case ACTYPE.COMPANY_LOCATIONS_WITH_BOM_SHIPTO:
                case ACTYPE.NON_CUSTOMER_LOCATION:
                    response($.map(result, function (item) {
                        return {
                            label: item.DisplayName,
                            guid: null,
                            initial: null,
                            parentID: item.ParentID,
                            value: item.ID,
                            usertype: item.IsContpaqVendor,
                            userImage: item.UserImage
                        };
                    }));
                    break;
                case ACTYPE.SHIPTO:
                    response($.map(result, function (item) {
                        return {
                            label: item.Name,
                            guid: null,
                            initial: null,
                            parentID: null,
                            value: item.ID,
                            usertype: null,
                            userImage: null,
                        };
                    }));
                    break;
                case ACTYPE.TRAINING_MATRIX_ENTITY:
                    response($.map(result, function (item) {
                        return {
                            label: item.Name,
                            initial: null,
                            value: item.ID,
                            entitytype: item.EntityType,
                            isCustomUserGroup: item.IsCustomUserGroup,
                            acType: ACTYPE.TRAINING_MATRIX_ENTITY
                        };
                    }));
                    break;
                case ACTYPE.CHILD_ACCOUNT:
                    response($.map(result, function (item) {
                        return {
                            label: item.AccountName,
                            value: item.AccountID,
                            parentid: item.ParentAccountID
                        };
                    }));
                    break;

                case ACTYPE.PDT_PROJECT_NUMBER:
                    response($.map(result, function (item) {
                        return {
                            label: item.PDTProjectNumber + ": " + item.Name,
                            value: item.PDTProjectNumber
                        };
                    }));
                    break;
                case ACTYPE.SHIPTO_AND_CELL_LIST:
                    response($.map(result, function (item) {
                        return {
                            label: item.Name,
                            value: item.ID
                        };
                    }));
                    break;
                case ACTYPE.COMPANY_LOCATION_AND_CELLLIST:
                    response($.map(result, function (item) {
                        return {
                            label: item.NameWithParent,
                            value: item.ID,
                            entitytype: item.EntityType
                        };
                    }));
                    break;
                case ACTYPE.CR_AND_USER:
                    response($.map(result, function (item) {
                        return {
                            label: item.EntityName,
                            value: item.EntityID,
                            entitytype: item.EntityType
                        };
                    }));
                    break;
                case ACTYPE.CUSTOMERPART_WITH_SHIPTO_DESCRIPTION:
                    response($.map(result, function (item) {
                        return {
                            label: item.EntityName,
                            value: item.EntityID
                        };
                    }));
                    break;
                default:
                    response($.map(result, function (item) {
                        return {
                            entitytype: item.EntityType,
                            label: item.StandardName,
                            guid: item.GUID,
                            initial: item.Initial,
                            value: item.ID,
                            userImage: item.UserImage,
                            salaryType: item.SalaryType
                        };
                    }));
                    break;
            }
        }
    }


    /* ========================================================================
     *  delete confirmation
     * ========================================================================
    */
    //  set delete
    function setDelete(e) {
        e.addClass('hidden');
        $(DELETE_CONFIRM).removeClass('hidden');
        $(DELETE_CANCEL).removeClass('hidden');

    }


    // set confirm delete button
    function setDeleteConfirm(e) {
        e.data().value = true;
        getControlSet(e);
    }


    // set cancel delete button
    function setDeleteCancel(e) {
        e.addClass('hidden');
        $(DELETE_CONFIRM).addClass('hidden');
        $(DELETE_ELEM).removeClass('hidden');
    }


    /* ========================================================================
     *  date nav
     * ========================================================================
    */

    //  date nav previous button
    function setDateNavPrev(e) {
        var dateNavSelect = e.parent().find('select');
        var selectIndex = dateNavSelect.find('option:selected').index();
        dateNavSelect.find('option').eq(selectIndex).prop('selected', false);
        dateNavSelect.find('option').eq(selectIndex - 1).prop('selected', true);

        if (selectIndex == 1) {
            e.prop('disabled', true).find('i').removeClass('fa-angle-left');
        } else if (selectIndex == dateNavSelect.children().length - 1) {
            $(e.parent().children()[3]).prop("disabled", false).find('i').addClass('fa-angle-right');
        }
        e.data('value', dateNavSelect.val());
        dateNavSelect.data('value', dateNavSelect.val())

        getControlSet(dateNavSelect);
    }


    //  date nav next button
    function setDateNavNext(e) {
        var dateNavSelect = e.parent().find('select');
        var selectIndex = dateNavSelect.find('option:selected').index();
        dateNavSelect.find('option').eq(selectIndex).prop('selected', false);
        dateNavSelect.find('option').eq(selectIndex + 1).prop('selected', true);

        if (selectIndex == 0) {
            $(e.parent().children()[0]).prop("disabled", false).find('i').addClass('fa-angle-left');
        } else if (selectIndex == dateNavSelect.children().length - 2) {
            e.prop('disabled', true).find('i').removeClass('fa-angle-right');
        }
        e.data('value', dateNavSelect.val());
        dateNavSelect.data('value', dateNavSelect.val())

        getControlSet(dateNavSelect);
    }


    //  date nav today button
    function setDateNavToday(e) {
        var dateNavSelect = e.parent().find('select');
        var selectIndex = dateNavSelect.find('option:selected').index();
        dateNavSelect.find('option').eq(selectIndex).prop('selected', false);
        var options = dateNavSelect.find('option');
        var todayDate = new Date();
        var optionDate = new Date($(options[0]).val());
        var index = 0;
        while (optionDate.getTime() < todayDate.getTime()) {
            optionDate = new Date($(options[++index]).val());
        }

        dateNavSelect.find('option').eq(index - 1).prop('selected', true);

        e.data('value', dateNavSelect.val());
        dateNavSelect.data('value', dateNavSelect.val())
        $(e.parent().children()[0]).prop("disabled", false).find('i').addClass('fa-angle-left');
        $(e.parent().children()[3]).prop("disabled", false).find('i').addClass('fa-angle-right');

        getControlSet(dateNavSelect);
    }


    //  change
    function setDateNavSelect(e) {
        e.data().value = e.val();
        var selectIndex = e.find('option:selected').index();
        var enablePrev = true;
        var enableNext = true;
        if (selectIndex == 0) {
            enablePrev = false;
            $(e.parent().prev()).prop('disabled', true).find('i').removeClass('fa-angle-left');
        } else if (selectIndex == $(DATENAV_SELECT_ELEM).children().length - 1) {
            enableNext = false;
            $(e.parent().next().next()).prop('disabled', true).find('i').removeClass('fa-angle-right');
        }
        if (enablePrev) $(e.parent().prev()).prop('disabled', false).find('i').addClass('fa-angle-left');
        if (enableNext) $(e.parent().next().next()).prop('disabled', false).find('i').addClass('fa-angle-right');

        getControlSet(e);
    }




    /* ========================================================================
     *  division & child combo control
     * ========================================================================
    */

    function setDivisionChildChange(e, comboType) {
        switch (parseInt(comboType)) {
            case COMBOTYPE.DIVISION_CELL:
                setSelectDivCellComboChange(e);
                break;
            case COMBOTYPE.DIVISIONWITHFOCUSFACTORY_CELL:
                setSelectDivFFCellComboChange(e);
                break;
            case COMBOTYPE.DIVISIONWITHFOCUSFACTORY_SUPERCELL:
                setSelectDivFFSuperCellComboChange(e);
                break;
            case COMBOTYPE.DIVISION_FOCUSFACTORYCELL:
                setSelectDivFFCellComboChange(e);
                setSelectDivFFComboChange(e);
                break;
            case COMBOTYPE.DIVISIONFOCUSFACTORY_CELL:
                setSelectDivFFCellComboChange(e);
                break;
        }
    }

    function handleArrows(e, childCount) {
        var controlParent = e.closest('.control');
        var index = e.find('option[value="' + e.data().value + '"]').index();
        var arrowPrev = controlParent.find(DIVISION_CHILD_PREV + "," + FOCUSFACTORY_CHILD_PREV);
        var arrowNext = controlParent.find(DIVISION_CHILD_NEXT + "," + FOCUSFACTORY_CHILD_NEXT);

        if (index == 0) {
            disableLeftArrow(arrowPrev);
            enableRightArrow(arrowNext);
        } else if (index == e.find('option').length - 1) {
            enableLeftArrow(arrowPrev);
            disableRightArrow(arrowNext);
        } else {
            enableLeftArrow(arrowPrev);
            enableRightArrow(arrowNext);
        }

        // since we start with the first option selected, always disable the previous cell arrow
        var prev = e.closest('.control').find(SELECT_PREV);
        var next = e.closest('.control').find(SELECT_NEXT);
        disableLeftArrow(prev);
        if (childCount <= 1) {
            disableRightArrow(next);
        } else {
            enableRightArrow(next);
        }
    }

    function handleArrowsAgainstMaxAndMinDate(datepicker) {

        var currentDate = new Date(datepicker.data('value'));
        var controlParent = datepicker.closest('.control');
        var arrowPrev = controlParent.find(DATEPICKER_PREV);
        var arrowNext = controlParent.find(DATEPICKER_NEXT);

        var maxDate = datepicker.datepicker("option", "maxDate");
        if (maxDate && currentDate.addDay(1) > new Date(maxDate)) {
            disableRightArrow(arrowNext);
        } else {
            enableRightArrow(arrowNext);
        }

        var minDate = datepicker.datepicker("option", "minDate");
        if (minDate && currentDate.addDay(-1) < new Date(minDate)) {
            disableLeftArrow(arrowPrev);
        } else {
            enableLeftArrow(arrowPrev);
        }
    }

    function enableLeftArrow(e) {
        e.attr('disabled', false).prop('disabled', false).find('i').addClass('fa-angle-left');
    }


    function disableLeftArrow(e) {
        e.attr('disabled', true).prop('disabled', true).find('i').removeClass('fa-angle-left');
    }


    function enableRightArrow(e) {
        e.attr('disabled', false).prop('disabled', false).find('i').addClass('fa-angle-right');
    }


    function disableRightArrow(e) {
        e.attr('disabled', true).prop('disabled', true).find('i').removeClass('fa-angle-right');
    }


    //  change division cell combo
    function setSelectDivCellComboChange(e) {
        e.data('value', e.val()).attr('data-value', e.val());
        var data = e.data();

        //  get cell list
        var controlParent = e.closest('.control');
        var childCtrl = controlParent.find('#TOPCTRL_COMBOCHILD');
        var required = childCtrl.data('requiredcell');
        var allCell = childCtrl.data('allcell');
        var enableArrows = childCtrl.data('enablearrows');

        var URL = "/Common/Common/GetCellListByDivisionID";

        var userItem = me.getUserProps();
        var options = {
            params: { ID: +e.data().value },
            url: URL,
            callback: afterData
        };
        me.AJAX.setAJAX(options);

        function afterData(data) {
            var result = data.data;
            var ar = [];

            if (allCell || +e.data().value == 1 || result.length == 0) { // Check to see if "All Divisions" is selected
                ar.push("<option value='-1'>" + childCtrl.data().labelallcells + "</option>");
                childCtrl.data().value = '-1';
                childCtrl.val("-1");
            } else if (!required) {
                ar.push("<option value='-1'>" + childCtrl.data().labelselectcell + "</option>");
                childCtrl.data().value = '-1';
                childCtrl.val("-1");
            } else {
                childCtrl.data().value = result[0].ID;
                childCtrl.val(result[0].ID);
            }
            for (var i = 0, len = result.length; i < len; i++) {
                var d = result[i];
                ar.push(
                    "<option value='" + d.ID + "'>" + d.StandardName + "</option>"
                );
            }

            childCtrl.html(ar.join(''));
            if (enableArrows) handleArrows(e, ar.length);

            getControlSet(e);
        }
    }


    //  change division ff cell combo
    function setSelectDivFFCellComboChange(e) {
        e.data('value', e.val()).attr('data-value', e.val());
        var data = e.data();

        //  get cell list
        var controlParent = e.closest('.control');
        var childCtrl = controlParent.find('#TOPCTRL_COMBOCHILD');
        var required = childCtrl.data('requiredcell');
        var allCell = childCtrl.data('allcell');
        var enableArrows = childCtrl.data('enablearrows');

        var URL = "/Common/Common/GetCellListByDivisionFocusFactoryID";

        var userItem = me.getUserProps();
        var options = {
            params: { ID: +e.data().value },
            url: URL,
            callback: afterData
        };
        me.AJAX.setAJAX(options);

        function afterData(data) {
            var result = data.data;
            var ar = [];

            if (allCell || +e.data().value == 1) { // Check to see if "All Divisions" is selected
                ar.push("<option value='-1'>" + childCtrl.data().labelallcells + "</option>");
                childCtrl.data().value = '-1';
                childCtrl.val("-1");
            } else if (!required || result.length == 0) {
                ar.push("<option value='-1'>" + childCtrl.data().labelselectcell + "</option>");
                childCtrl.data().value = '-1';
                childCtrl.val("-1");
            } else {
                childCtrl.data().value = result[0].ID;
                childCtrl.val(result[0].ID);
            }
            for (var i = 0, len = result.length; i < len; i++) {
                var d = result[i];
                ar.push("<option value='" + d.ID + "'>" + d.StandardName + "</option>");
            }

            childCtrl.html(ar.join(''));

            if (enableArrows) handleArrows(e, ar.length);

            getControlSet(e);
        }
    }

    //  change division ff combo
    function setSelectDivFFComboChange(e) {
        e.data('value', e.val()).attr('data-value', e.val());
        var data = e.data();

        //  get cell list
        var controlParent = e.closest('.control');
        var childCtrl = controlParent.find('[data-fd=page-ctrl-combofocusfactorychild]');
        var required = childCtrl.data('requiredff');
        var allCell = childCtrl.data('allff');
        var enableArrows = childCtrl.data('enablearrows');

        var URL = "/Common/Common/ReturnSearchFocusFactory";

        var userItem = me.getUserProps();
        var options = {
            params: { ID: +e.data().value },
            url: URL,
            callback: afterData
        };
        me.AJAX.setAJAX(options);

        function afterData(data) {
            var result = data.data;
            var ar = [];

            if (allCell || +e.data().value == 1) { // Check to see if "All Divisions" is selected
                ar.push("<option value='-1'>" + childCtrl.data().labelallff + "</option>");
                childCtrl.data().value = '-1';
                childCtrl.val("-1");
            } else if (!required || result.length == 0) {
                ar.push("<option value='-1'>" + childCtrl.data().labelselectff + "</option>");
                childCtrl.data().value = '-1';
                childCtrl.val("-1");
            } else {
                childCtrl.data().value = result[0].FocusFactoryID;
                childCtrl.val(result[0].FocusFactoryID);
            }
            for (var i = 0, len = result.length; i < len; i++) {
                var d = result[i];
                ar.push("<option value='" + d.FocusFactoryID + "'>" + d.StandardName + "</option>");
            }

            childCtrl.html(ar.join(''));

            if (enableArrows) handleArrows(e, ar.length);

            getControlSet(e);
        }
    }


    //  change division ff supercell combo
    function setSelectDivFFSuperCellComboChange(e) {
        e.data('value', e.val()).attr('data-value', e.val());
        var data = e.data();

        //  get cell list
        var controlParent = e.closest('.control');
        var childCtrl = controlParent.find('#TOPCTRL_COMBOCHILD');
        var required = childCtrl.data('requiredsupercell');
        var allSuperCell = childCtrl.data('allsupercell');
        var enableArrows = childCtrl.data('enablearrows');

        var URL = "/Common/Common/GetSuperCellListByDivisionFocusFactoryID";

        var userItem = me.getUserProps();
        var options = {
            params: { ID: +e.data().value },
            url: URL,
            callback: afterData
        };
        me.AJAX.setAJAX(options);

        function afterData(data) {
            var result = data.data;
            var ar = [];

            if (allSuperCell || +e.data().value == 1) { // Check to see if "All Divisions" is selected
                ar.push("<option value='-1'>" + childCtrl.data().labelallsupercells + "</option>");
                childCtrl.data().value = '-1';
                childCtrl.val("-1");
            } else if (!required || result.length == 0) {
                ar.push("<option value='-1'>" + childCtrl.data().labelselectsupercell + "</option>");
                childCtrl.data().value = '-1';
                childCtrl.val("-1");
            } else {
                childCtrl.data().value = result[0].ID;
                childCtrl.val(result[0].ID);
            }
            for (var i = 0, len = result.length; i < len; i++) {
                var d = result[i];
                ar.push(
                    "<option value='" + d.ID + "'>" + d.StandardName + "</option>"
                );
            }

            childCtrl.html(ar.join(''));

            if (enableArrows) handleArrows(e, ar.length);

            getControlSet(e);
        }
    }


    // click previous division/child arrow
    function setDivisionChildPrev(e) {
        var select = e.closest('.control').find(SELECT_DIVISION_CHILD_COMBO_ELEM);
        var comboType = select.data().combotype;
        var index = select.find('option:selected').index();
        var options = select.find('option');
        if (index != 0) {
            select.val(options[index - 1].value);
            setDivisionChildChange(select, comboType);
        }
    }


    // click next division/child arrow
    function setDivisionChildNext(e) {
        var select = e.closest('.control').find(SELECT_DIVISION_CHILD_COMBO_ELEM);
        var comboType = select.data().combotype;
        var index = select.find('option:selected').index();
        var options = select.find('option');

        if (index != options.length - 1) {
            select.val(options[index + 1].value);
            setDivisionChildChange(select, comboType);
        }
    }

    // click previous division/child arrow
    function setFocusFactoryChildPrev(e) {
        var select = e.closest('.control').find(SELECT_FOCUSFACTORY_CHILD_COMBO_ELEM);
        var comboType = select.data().combotype;
        var index = select.find('option:selected').index();
        var options = select.find('option');
        if (index != 0) {
            select.val(options[index - 1].value);
            setDivisionChildChange(select, comboType);
        }
    }


    // click next division/child arrow
    function setFocusFactoryChildNext(e) {
        var select = e.closest('.control').find(SELECT_FOCUSFACTORY_CHILD_COMBO_ELEM);
        var comboType = select.data().combotype;
        var index = select.find('option:selected').index();
        var options = select.find('option');

        if (index != options.length - 1) {
            select.val(options[index + 1].value);
            setDivisionChildChange(select, comboType);
        }
    }



    /* ========================================================================
     *  events
     * ========================================================================
    */

    //  focus
    function setFocus(e) {
        e.data().initial = e.val();
    }


    //  blur
    function setInputBlur(e) {
        var val = e.val().trim();

        e.data().value = val;
        if (e.data().value !== e.data().initial) {
            e.data().initial = val;
            getControlSet(e);
        }
    }


    //  click
    function setButtonClick(e) {
        e.data().value = true;
        if (e.data('noedit')) {
            return;
        }
        getControlSet(e);
    }


    //  collpase / expand
    function setButtonCollapseClick(e) {
        if (!e.hasClass('disabled')) {
            if (e.children('i').hasClass('fa-expand')) {
                e.data().value = false;
                e.children('i').removeClass('fa-expand').addClass('fa-compress');
            } else {
                e.data().value = true;
                e.children('i').removeClass('fa-compress').addClass('fa-expand');
            }
            getControlSet(e);
        }
    }


    //  toggle
    function setToggleClick(e) {
        e.data().value = !e.data().value;
        e.toggleClass("active btn-success", e.data().value).toggleClass("btn-secondary", !e.data().value);
        e.find('i').toggleClass("fa-check-square-o", e.data().value).toggleClass("fa-square-o", !e.data().value);
        getControlSet(e);
    }

    child.setToggle = function (e, value) {
        if (e && e.length) {
            e.data().value = value;
            e.toggleClass("active btn-success", e.data().value).toggleClass("btn-secondary", !e.data().value);
            e.find('i').toggleClass("fa-check-square-o", e.data().value).toggleClass("fa-square-o", !e.data().value);
        }
    }


    //  change
    function setSelectChange(e) {
        e.data('value', e.val());
        if (e.data('enablearrows')) {
            var options = e.find('option');
            var index = options.index($(e.find('option:selected')));
            var prev = e.closest('.control').find(SELECT_PREV);
            var next = e.closest('.control').find(SELECT_NEXT);
            if (index == 0) {
                prev.attr('disabled', true).prop('disabled', true).find('i').removeClass('fa-angle-left');
                next.attr('disabled', false).prop('disabled', false).find('i').addClass('fa-angle-right');
            } else if (index == e.find('option').length - 1) {
                prev.attr('disabled', false).prop('disabled', false).find('i').addClass('fa-angle-left');
                next.attr('disabled', true).prop('disabled', true).find('i').removeClass('fa-angle-right');
            } else {
                prev.attr('disabled', false).prop('disabled', false).find('i').addClass('fa-angle-left');
                next.attr('disabled', false).prop('disabled', false).find('i').addClass('fa-angle-right');
            }
        }

        getControlSet(e);
    }


    // previous select arrow
    function setSelectPrev(e) {
        var select = e.closest('.control').find(SELECT_ELEM);
        var options = select.find('option');
        var index = options.index($(select.find('option:selected')));
        if (index != 0) {
            select.val(options[index - 1].value);
            setSelectChange(select);
        }
    }


    // next select arrow
    function setSelectNext(e) {
        var select = e.closest('.control').find(SELECT_ELEM);
        var options = select.find('option');
        var index = options.index($(select.find('option:selected')));
        if (index != options.length - 1) {
            select.val(options[index + 1].value);
            setSelectChange(select);
        }
    }


    function setEvents() {
        //  set input
        var docElem = $(document);
        if ($(INPUT_ELEM).length) {
            docElem.off('focus.pagectrl_input blur.pagectrl_input keyup.pagectrl_input', INPUT_ELEM)
                .on({
                    'focus.pagectrl_input': function () {
                        setFocus($(this));
                    },
                    'blur.pagectrl_input': function () {
                        setInputBlur($(this));
                    },
                    'keyup.pagectrl_input': function (event) {
                        if (+event.which === 13 || +event.keyCode === 13) {
                            $(this).blur();
                        }
                    }
                }, INPUT_ELEM);
        }
        if ($(INPUTKEYUP_ELEM).length) {
            docElem.off('focus.pagectrl_inputkey keyup.pagectrl_inputkey input.pagectrl_inputkey', INPUTKEYUP_ELEM)
                .on({
                    'focus.pagectrl_inputkey': function () {
                        setFocus($(this));
                    },
                    'keyup.pagectrl_inputkey': function (event) {
                        if (event.which == 13 || event.keyCode == 13) setInputBlur($(this));
                    },
                    'input.pagectrl_inputkey': function () {
                        var elem = $(this);
                        if (this.controlDelay) {
                            clearTimeout(this.controlDelay);
                            this.controlDelay = undefined;
                        }
                        this.controlDelay = setTimeout(function () {
                            setInputBlur(elem);
                        }, DELAY);
                    }
                }, INPUTKEYUP_ELEM);
        }
        if ($(BUTTON_ELEM).length) {
            docElem.off('click.pagectrl_btn', BUTTON_ELEM)
                .on({
                    'click.pagectrl_btn': function () {
                        setButtonClick($(this));
                    }
                }, BUTTON_ELEM);
        }


        //  set button collapse/expand
        if ($(COLLAPSE_ELEM).length) {
            docElem.off('click.pagectrl_btncollapse', COLLAPSE_ELEM)
                .on({
                    'click.pagectrl_btncollapse': function () {
                        setButtonCollapseClick($(this));
                    }
                }, COLLAPSE_ELEM);
        }


        //  set toggle
        if ($(TOGGLE_ELEM).length) {
            docElem.off('click.pagectrl_toggle', TOGGLE_ELEM);
            docElem.on({
                'click.pagectrl_toggle': function () {
                    setToggleClick($(this));
                }
            }, TOGGLE_ELEM);
        }


        if ($(SELECT_ELEM).length) {
            docElem.off('focus.pagectrl_select change.pagectrl_select', SELECT_ELEM)
                .off('click.pagectrl_selectPrev', SELECT_PREV)
                .off('click.pagectrl_selectNext', SELECT_NEXT)
                .on({
                    'focus.pagectrl_select': function () {
                        setFocus($(this));
                    },
                    'change.pagectrl_select': function () {
                        setSelectChange($(this));
                    }
                }, SELECT_ELEM)
                .on({
                    'click.pagectrl_selectPrev': function () {
                        setSelectPrev($(this));
                    }
                }, SELECT_PREV)
                .on({
                    'click.pagectrl_selectNext': function () {
                        setSelectNext($(this));
                    }
                }, SELECT_NEXT);
        }


        //  select div/child combo
        if ($(SELECT_DIVISION_CHILD_COMBO_ELEM).length) {
            docElem.off('focus.pagectrl_select change.pagectrl_select', SELECT_DIVISION_CHILD_COMBO_ELEM)
                .off('click.pagectrl_divisionFFPrev', DIVISION_CHILD_PREV)
                .off('click.pagectrl_divisionFFNext', DIVISION_CHILD_NEXT)
                .on({
                    'focus.pagectrl_select': function () {
                        setFocus($(this));
                    },
                    'change.pagectrl_select': function () {
                        var elem = $(this);
                        var comboType = elem.data().combotype;
                        setDivisionChildChange($(this), comboType);
                    }
                }, SELECT_DIVISION_CHILD_COMBO_ELEM)
                .on({
                    'click.pagectrl_divisionFFPrev': function () {
                        setDivisionChildPrev($(this));
                    }
                }, DIVISION_CHILD_PREV)
                .on({
                    'click.pagectrl_divisionFFNext': function () {
                        setDivisionChildNext($(this));
                    }
                }, DIVISION_CHILD_NEXT);
        }

        //  select focusfactory/child combo
        if ($(SELECT_FOCUSFACTORY_CHILD_COMBO_ELEM).length) {
            docElem.off('focus.pagectrl_select change.pagectrl_select', SELECT_FOCUSFACTORY_CHILD_COMBO_ELEM)
                .off('click.pagectrl_FFPrev', FOCUSFACTORY_CHILD_PREV)
                .off('click.pagectrl_FFNext', FOCUSFACTORY_CHILD_NEXT)
                .on({
                    'focus.pagectrl_select': function () {
                        setFocus($(this));
                    },
                    'change.pagectrl_select': function () {
                        var elem = $(this);
                        var comboType = elem.data().combotype;
                        setDivisionChildChange($(this), comboType);
                    }
                }, SELECT_FOCUSFACTORY_CHILD_COMBO_ELEM)
                .on({
                    'click.pagectrl_FFPrev': function () {
                        setFocusFactoryChildPrev($(this));
                    }
                }, FOCUSFACTORY_CHILD_PREV)
                .on({
                    'click.pagectrl_FFNext': function () {
                        setFocusFactoryChildNext($(this));
                    }
                }, FOCUSFACTORY_CHILD_NEXT);
        }


        // datenav control
        if ($(DATENAV_SELECT).length) {
            docElem.off('click.pagectrl_dateNavPrev', DATENAV_PREV)
                .off('click.pagectrl_dateNavNext', DATENAV_NEXT)
                .off('click.pagectrl_dateNavToday', DATENAV_TODAY)
                .off('focus.pagectrl_dateNavSelect change.pagectrl_dateNavSelect', DATENAV_SELECT)
                .on({
                    'click.pagectrl_dateNavPrev': function () {
                        setDateNavPrev($(this));
                    }
                }, DATENAV_PREV)
                .on({
                    'click.pagectrl_dateNavNext': function () {
                        setDateNavNext($(this));
                    }
                }, DATENAV_NEXT)
                .on({
                    'click.pagectrl_dateNavToday': function () {
                        setDateNavToday($(this));
                    }
                }, DATENAV_TODAY)
                .on({
                    'focus.pagectrl_dateNavSelect': function () {
                        setFocus($(this));
                    },
                    'change.pagectrl_dateNavSelect': function () {
                        setDateNavSelect($(this));
                    }
                }, DATENAV_SELECT);
        }


        //  set delete
        if ($(DELETE_ELEM).length || $(DELETE_CONFIRM).length || $(DELETE_CANCEL).length) {
            docElem.off('click.pagectrl_delete', DELETE_ELEM)
                .on({
                    'click.pagectrl_delete': function () {
                        setDelete($(this));
                    }
                }, DELETE_ELEM)
                .off('click.pagectrl_confirmdelete', DELETE_CONFIRM)
                .on({
                    'click.pagectrl_delete': function () {
                        setDeleteConfirm($(this));
                    }
                }, DELETE_CONFIRM)
                .off('click.pagectrl_canceldelete', DELETE_CANCEL)
                .on({
                    'click.pagectrl_delete': function () {
                        setDeleteCancel($(this));
                    }
                }, DELETE_CANCEL);
        }


        // save clicked element so that the top control datepicker will
        // function correctly
        docElem.off('mousedown.topControlDatePickerCheck')
            .on('mousedown.topControlDatePickerCheck', function (e) {
                topControlClickedElement = e.target;
            });
    }


    /* ========================================================================
     *  callback
     * ========================================================================
    */
    //  get control set
    function getControlSet(e) {
        var data = e.data();
        var ctrlAR = {};

        //  reset
        list = $(ELEM).add("[data-range='true']");

        list.each(function () {
            var ctrl = $(this);
            if (ctrl.closest('li').hasClass('hidden')) {
                return;
            }
            var ctrlName = ctrl.data().name;

            if (ctrlName == 'daterange') {
                var dateInputs = ctrl.find('input');
                ctrlAR[$(dateInputs[0]).data('name')] = $(dateInputs[0]).data('value');
                ctrlAR[$(dateInputs[1]).data('name')] = $(dateInputs[1]).data('value');
            } else {
                let d = ctrl.data();
                ctrlAR[ctrlName] = d.value;
                ctrlAR[ctrlName + "RawData"] = d;
            }
        });

        if (data.name == "dateNavPrev" || data.name == "dateNavNext" || data.name == "dateNavToday") {
            data.name = "dateNavSelect";
        }

        //  fix for FOX
        //  sk  5/7
        var foxDate = {
            //foxDateValue: data.value,   //  these two dates don't match
            //datenavselect: ctrlAR.dateNavSelect, //  these two dates don't match
            foxDateValue: data.value
        };


        var activeInfo = {
            __activeCtrl: data.name,
            tag: data.tag
        };

        var result = $.extend({}, ctrlAR, activeInfo, foxDate);

        //  reset buttons
        if (data.type === 'button') {
            e.data().value = false;
        }
        updateUrlState(e, result);
        me.setCallBackFromData(e, result);
    }


    /* ========================================================================
     *  public methods
     * ========================================================================
    */

    //  set top control element
    child.setTopControlElement = function () {
        setTopControlElement();
    };


    //  set top control events
    child.setTopControlElementEvents = function () {
        setEvents();
    };

    child.setFormat = function (element) {
        setFormat(element);
    }

    /* ========================================================================
     *  return
     * ========================================================================
    */
    return child;
}(jQuery, FD));

FD.CONTROL = (function ($, me) {
    var child = me.CONTROL || {};

    /*
     * Helper function to help re-position tables after showing new top controls
     * dontFireResize should only be used if you're calling this function multiple times in a row
     * and don't want to fire the resize event until the final control is shown/hidden
     */
    child.showTopControl = function (elem, dontFireResize) {
        if (!(elem instanceof jQuery)) {
            elem = $(elem);
        }
        elem.removeClass('hidden');

        if (!dontFireResize) {
            $(window).trigger('resize');
        }
    };


    /*
     * Helper function to help re-position tables after hiding top controls
     * dontFireResize should only be used if you're calling this function multiple times in a row
     * and don't want to fire the resize event until the final control is shown/hidden
     */
    child.hideTopControl = function (elem, dontFireResize) {
        if (!(elem instanceof jQuery)) {
            elem = $(elem);
        }
        elem.addClass('hidden');

        if (!dontFireResize) {
            $(window).trigger('resize');
        }
    };


    /*
     * Helper function to help re-position tables after replacing top controls
     */
    child.replaceTopControls = function (html) {
        $('[data-sitecontrol]').html(html);

        $(window).trigger('resize');
    };

    return child;
}(jQuery, FD));